/* eslint-disable no-unused-vars */
import { Form, Formik } from "formik";
import React, { useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import { toast } from "react-hot-toast";
import { useDispatch } from "react-redux";
import Select from "react-select";
import { getEmployees } from "../../store/actions/employees.action";
import {
  addCashierAgentPermission,
  userType,
} from "../../utils/helpers/objectHelpers";
import {
  agentInitialValues,
  agentSchema,
} from "../../utils/helpers/validationHelpers";
import { AgentService } from "../../utils/services/agent.service";
import { EmployeeService } from "../../utils/services/employees.service";
import "./modal.css";

function AddNewAgentModal({
  domainBrand,
  countries,
  show,
  handleClose,
  type,
  title,
}) {
  const dictionary = domainBrand.domainBrand["languageDictionary"];
  const [getOption, setGetOption] = useState([]);
  const [loading, setLoading] = useState(false);
  const [reset, setReset] = useState();
  const [errors, setErrors] = useState({});
  const [roles, setRoles] = useState({});
  const [maxAmount, setMaxAmount] = useState({});
  const [userRole, setUserRole] = useState({});
  const [approveAccountOnExecution, setApproveAccountOnExecution] =
    useState(false);

  const phoneCodes = countries["supportedPhoneCodes"];
  const countryList = countries["countries"];
  const currencyList = countries["currencies"];
  const formikRef = useRef();

  const toggleCheckBox = () =>
    setApproveAccountOnExecution(!approveAccountOnExecution);

  const dispatch = useDispatch();

  const addNewAgent = async (values) => {
    setLoading(true);
    const payload = {
      firstName: values?.firstName,
      lastName: values?.lastName,
      email: values?.email,
      phone: `${values?.phoneCountryCode?.telephoneCode}${values?.phone}`,
      staffActiveDirectoryId: values?.staffId,
      addressEntityDTO: {
        address1: values?.addressLine1,
        address2: values?.addressLine2,
        city: values?.city,
        countryCommonName: values?.country?.common_name,
        postcode: values?.postCode,
        province: values?.province,
        countryIso3: values?.country?.iso3Code,
      },
      ableToPayIn: values?.enablePayIn,
      ableToPayOut: values?.enablePayOut,
      ableToBeReceiver: values?.paymentCollector,
      ableToRefund: values?.enableRefund,
      ableToFund: values?.enableFundWallet,
      ableToWithdraw: values?.enableWithdrawFromWallet,
      ableToCreateWallet: values?.enableCreateWallet,
      ableToSeeTransactions: values?.seeTransactions,
      ableToSeeDetailedTransactions: values?.seeDetailedTransactions,
      ableToSeeDetailedTransactionSummary: values?.seeTransactionSummary,
      ableToSeePaidOutTransactions: values?.paidOutTransactions,
      ableToSeeApiTransactions: values?.seeApiTransactions,
      ableToSeeOpeningBalance: values?.seeOpeningBalance,
      ableToSeeOpeningBalanceHistory: values?.seeOpeningBalanceHistory,
      ableToSeeWalletLedger: values?.seeWalletLedger,
      enableMultipleCountryPayOut: values?.multipleCountries,
      profileApproved: values?.approveProfile,
      passwordExpires: values?.passwordExpires,
      passwordExpireType: values?.passwordExpireType?.value,
      ipAddress: "",
      maxAmounts: maxAmount,
      autoConfirmTransaction: true,
    };
    try {
      const response = await EmployeeService.addEmployee(payload);
      if (response.data.status === "SUCCESS") {
        toast.success(response?.data?.message);
        dispatch(getEmployees());
        reset({});
        setErrors({});
        setGetOption([]);
        setMaxAmount({});
        handleClose();
      } else {
        toast.error(response?.data?.message);
        reset({});
        setErrors({});
        setGetOption([]);
        setMaxAmount({});
      }
    } catch (error) {
      toast.error(error?.data?.message);
      setLoading(false);
      return error;
    }
    setLoading(false);
  };

  const onChangeInputValue = (val, index) => {
    let temp = getOption;
    temp[index].value = val.target.value;
    temp[index].name = val.target.name;
    setMaxAmount({ ...maxAmount, [val.target.name]: val.target.value });
  };

  const onChangeInputRole = (val) => {
    setRoles({ ...roles, [val.target.name]: val.target.checked });
  };

  return (
    <Modal
      show={show}
      backdrop="static"
      keyboard={false}
      size={"xl"}
      scrollable
    >
      <Modal.Header closeButton={false}>
        <Modal.Title className="fw-bold">
          {dictionary
            ? dictionary["para_register_pay_center"]
            : "Register Agent/Branch"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="card-body">
          <Formik
            initialValues={{ ...agentInitialValues }}
            validationSchema={agentSchema}
            onSubmit={addNewAgent}
            innerRef={formikRef}
          >
            {({
              values,
              handleChange,
              handleBlur,
              setFieldValue,
              handleSubmit,
              errors,
            }) => {
              const disablePhoneInput =
                typeof values?.phoneCountryCode?.value === "undefined" ||
                values?.phoneCountryCode?.value === "";
              console.log(errors);

              return (
                <Form className="needs-validation" onSubmit={handleSubmit}>
                  {/* CASHIER INFORMATION */}
                  <div className="col-lg-12 col-md-12">
                    <h6 className="text-center fw-bold qtext-uppercase pt-3 pb-3">
                      {dictionary
                        ? dictionary["para_register_a_pay_center_item_here"]
                        : "Provide details of the Agent you wish to register."}
                    </h6>

                    {type !== "new-role" && (
                      <div className="form-row">
                        {/* <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary
                              ? dictionary["para_agent_name"]
                              : "Agent Name"}
                          </label>
                          <input
                            type="agentName"
                            name="agentName"
                            id="agentName"
                            value={values.firstName}
                            className={`form-control ${
                              errors?.firstName ? "is-invalid" : ""
                            }`}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            required
                          />
                        </div> */}

                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary
                              ? dictionary["para_first_name"]
                              : "First Name"}
                          </label>
                          <input
                            type="text"
                            name="firstName"
                            id="firstName"
                            value={values.firstName}
                            className={`form-control ${
                              errors?.firstName ? "is-invalid" : ""
                            }`}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            required
                          />
                        </div>

                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary
                              ? dictionary["l_last_name"]
                              : "Last Name"}
                          </label>
                          <input
                            type="text"
                            name="lastName"
                            id="lastName"
                            value={values.lastName}
                            className={`form-control ${
                              errors["lastName"] ? "is-invalid" : ""
                            }`}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            required
                          />
                        </div>
                      </div>
                    )}

                    <div className="form-row">
                      {type !== "new-role" && (
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary
                              ? dictionary["para_user_role"]
                              : "User Role"}
                          </label>
                          <Select
                            options={userType()}
                            isClearable={false}
                            maxMenuHeight={250}
                            menuPlacement="bottom"
                            //   menuPortalTarget={menuPortalTarget}
                            value={values.userRoles}
                            name="userRoles"
                            onChange={(option) => {
                              setFieldValue("userRoles", option);
                              setUserRole(option);
                            }}
                            className="is-invalid"
                          />
                        </div>
                      )}

                      <div className="col-md-6 col-lg-6 mb-3">
                        <label>
                          {dictionary ? dictionary["l_email"] : "Email"}
                        </label>
                        <input
                          type="email"
                          name="email"
                          id="email"
                          value={values.email}
                          className={`form-control ${
                            errors["email"] ? "is-invalid" : ""
                          }`}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          required
                        />
                      </div>
                    </div>

                    {type !== "new-role" && (
                      <div className="form-row">
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary
                              ? dictionary["para_province"]
                              : "Province"}
                          </label>
                          <input
                            type="text"
                            name="province"
                            id="province"
                            value={values.province}
                            className={`form-control`}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary
                              ? dictionary["para_address1"]
                              : "Address Line 1"}
                          </label>
                          <input
                            type="text"
                            name="addressLine1"
                            id="addressLine1"
                            value={values.addressLine1}
                            className={`form-control ${
                              errors["addressLine1"] ? "is-invalid" : ""
                            }`}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            required
                          />
                        </div>

                        {/* <div className="col-md-6 col-lg-6 mb-3">
                        <label>
                          {dictionary
                            ? dictionary["para_address_line_2"]
                            : "Address Line 2"}
                        </label>
                        <input
                          type="text"
                          name="addressLine2"
                          id="addressLine2"
                          value={values.addressLine2}
                          className={`form-control`}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </div> */}
                      </div>
                    )}

                    {type !== "new-role" && (
                      <div className="form-row">
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary
                              ? dictionary["para_address_line_2"]
                              : "Address Line 2"}
                          </label>
                          <input
                            type="text"
                            name="addressLine2"
                            id="addressLine2"
                            value={values.addressLine2}
                            className={`form-control`}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>

                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary ? dictionary["para_city"] : "City"}
                          </label>
                          <input
                            type="text"
                            name="city"
                            id="city"
                            value={values.city}
                            className={`form-control ${
                              errors["city"] ? "is-invalid" : ""
                            }`}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            required
                          />
                        </div>

                        {/* <div className="col-md-6 col-lg-6 mb-3">
                        <label>
                          {dictionary ? dictionary["l_country"] : "Country"}
                        </label>
                        <Select
                          options={countryList}
                          isClearable={false}
                          maxMenuHeight={250}
                          menuPlacement="bottom"
                          //   menuPortalTarget={menuPortalTarget}
                          value={values.country}
                          name="country"
                          onChange={(option) =>
                            setFieldValue("country", option)
                          }
                          className="is-invalid"
                        />
                      </div> */}
                      </div>
                    )}
                    {type !== "new-role" && (
                      <div className="form-row">
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary ? dictionary["l_country"] : "Country"}
                          </label>
                          <Select
                            options={countryList}
                            isClearable={false}
                            maxMenuHeight={250}
                            menuPlacement="bottom"
                            //   menuPortalTarget={menuPortalTarget}
                            value={values.country}
                            name="country"
                            onChange={(option) =>
                              setFieldValue("country", option)
                            }
                            className="is-invalid"
                          />
                        </div>
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary
                              ? dictionary["para_postcode"]
                              : "Area/Post code"}
                          </label>
                          <input
                            type="text"
                            name="postCode"
                            id="postCode"
                            value={values.postCode}
                            className={`form-control`}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>
                      </div>
                    )}

                    {type !== "new-role" && (
                      <div className="form-row mb-3">
                        <div className="col-lg-6 col-md-6 mb-3">
                          <label id="phoneNumber">
                            {dictionary
                              ? dictionary["para_phone_number"]
                              : "Phone Number"}
                          </label>
                          <div className="form-row">
                            <div className="col-md-5 col-lg-5 mb-3">
                              <Select
                                options={phoneCodes}
                                isClearable={false}
                                maxMenuHeight={250}
                                menuPlacement="bottom"
                                //   menuPortalTarget={menuPortalTarget}
                                value={values.phoneCountryCode}
                                name="phoneCountryCode"
                                onChange={(option) =>
                                  setFieldValue("phoneCountryCode", option)
                                }
                              />
                            </div>
                            <div
                              className="col-md-7 col-lg-7 mb-3"
                              id="phoneContainer"
                            >
                              <input
                                disabled={disablePhoneInput}
                                type="text"
                                name="phone"
                                id="phoneField"
                                value={values.phone}
                                className={`form-control ${
                                  errors["phone"] ? "is-invalid" : ""
                                }`}
                                onChange={handleChange}
                                required
                              />
                              {/* {errors["phone"] ? (
                              <div className="invalid-feedback">
                                Phone number is Required
                              </div>
                            ) : (
                              ""
                            )} */}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary
                              ? dictionary["PAYCENTRE_COD_-1423956344"]
                              : "Agent Code"}
                          </label>
                          <input
                            type="text"
                            name="staffId"
                            id="staffId"
                            value={values.staffId}
                            className={`form-control ${
                              errors["staffId"] ? "is-invalid" : ""
                            }`}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            required
                          />
                        </div>

                        {type !== "new-role" && (
                          <div className="col-lg-6 col-md-6 mb-3">
                            <label>
                              {dictionary
                                ? dictionary["WO_DEBITING_ACCOUN_1917861069"]
                                : "Debiting Account"}
                            </label>
                            <input
                              type="text"
                              name="tillAccountNumber"
                              id="tillAccountNumber"
                              value={values.tillAccountNumber}
                              className={`form-control`}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                          </div>
                        )}

                        {type !== "new-role" && (
                          <div className="col-lg-6 col-md-6 mb-3">
                            <label id="phoneNumber">
                              {dictionary
                                ? dictionary["SET_AUTOCONFIRM_TRA_861913692"]
                                : "Set auto-confirm transactions"}
                            </label>
                            <div className="form-row">
                              <div className="col-md-12 col-lg-12">
                                <Select
                                  options={currencyList}
                                  isClearable={false}
                                  maxMenuHeight={250}
                                  menuPlacement="bottom"
                                  value={values.transactionCurrency}
                                  name="transactionCurrency"
                                  onChange={(option) => {
                                    setFieldValue(
                                      "transactionCurrency",
                                      option
                                    );
                                    setGetOption(option);
                                  }}
                                  isMulti
                                />
                              </div>
                            </div>
                          </div>
                        )}

                        {type !== "new-role" && (
                          <div className="col-lg-6 col-md-6">
                            <Table striped>
                              <thead>
                                <tr>
                                  <th>
                                    <span style={{ fontSize: "15px" }}>
                                      {dictionary
                                        ? dictionary["l_currency"]
                                        : "Currency"}
                                    </span>
                                  </th>
                                  <th>
                                    <span style={{ fontSize: "15px" }}>
                                      {dictionary
                                        ? dictionary[
                                            "para_max_auto_confirm_amount"
                                          ]
                                        : "Maximum Auto-confirm Amount"}
                                    </span>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className="">
                                    {getOption?.map((i, idx) => {
                                      return (
                                        <>
                                          <p className="pt-3" key={idx}>
                                            {i.currencyCode}
                                          </p>
                                        </>
                                      );
                                    })}
                                  </td>

                                  <td>
                                    {getOption?.map((i, idx) => {
                                      return (
                                        <>
                                          <input
                                            className="form-control mb-2"
                                            key={idx}
                                            type={"text"}
                                            name={i.currencyCode}
                                            id={i.currencyCode}
                                            onChange={(val) =>
                                              onChangeInputValue(val, idx)
                                            }
                                          />
                                        </>
                                      );
                                    })}
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          </div>
                        )}
                      </div>
                    )}

                    <div className="form-row m-0">
                      <label className="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          defaultChecked={false}
                          onChange={toggleCheckBox}
                          name="createAdmin"
                        />
                        <span className="custom-control-label pointer fs-12">
                          <span>
                            {" "}
                            {dictionary
                              ? dictionary[
                                  "msg_please_create_paycenter_as_admin"
                                ]
                              : "I want to assign an admin to this Agent"}
                          </span>
                        </span>
                      </label>
                    </div>
                  </div>

                  {/* PERMISSION PART OF THE FORM  */}
                  <React.Fragment>
                    <div className="col-lg-12 col-md-12 mt-3">
                      <h6 className="text-center fw-bold text-uppercase pt-3 pb-4">
                        {dictionary
                          ? dictionary["WO_AGENTBRANCH_PERMISS_-1100080269"]
                          : "AGENT/BRANCH PERMISSION"}
                      </h6>
                      <div className="form form-row">
                        {addCashierAgentPermission().map((i, idx) => {
                          return (
                            <>
                              <div
                                className="col-lg-6 col-md-6 mb-3"
                                key={i.id}
                              >
                                <div
                                  className="d-flex flex-row align-items-center"
                                  key={i.id}
                                >
                                  <input
                                    type={"checkbox"}
                                    className="me-4"
                                    key={idx}
                                    style={{
                                      width: "24px",
                                      height: "16px",
                                    }}
                                    id={i.name}
                                    name={i.name}
                                    onChange={(val) => onChangeInputRole(val)}
                                  />

                                  <span className=" align-middle">
                                    {dictionary
                                      ? dictionary[i.dictionary]
                                      : `${i.role}`}
                                  </span>
                                  {i.id === 1 && (
                                    <span style={{ color: "red" }}>*</span>
                                  )}
                                </div>
                              </div>
                            </>
                          );
                        })}
                      </div>
                    </div>
                  </React.Fragment>

                  <div className="d-flex flex-row align-items-center justify-content-end">
                    <Button
                      variant="secondary"
                      onClick={() => {
                        handleClose();
                        setGetOption([]);
                        setErrors({});
                        setLoading(false);
                        setMaxAmount({});
                        setRoles({});
                      }}
                      className="me-3"
                    >
                      {dictionary ? dictionary["button_close"] : "Close"}
                    </Button>

                    <Button
                      variant="primary"
                      className="fw-bold px-3"
                      type={"submit"}
                    >
                      {dictionary ? dictionary["b_create"] : "Create"}
                      {loading ? (
                        <>
                          &nbsp;
                          <i className="fa fa-spinner fa-spin" />
                        </>
                      ) : (
                        ""
                      )}
                    </Button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </Modal.Body>

      <Modal.Footer></Modal.Footer>
    </Modal>
  );
}

export default AddNewAgentModal;
